// extracted by mini-css-extract-plugin
export default {"emptyState":"jGfvm9J"};